// Module
var code = `<div class="row"> <div class="col-12 text-center px-0 py-4"> <h1 class="form-title"></h1> </div> <div class="col-12 text-center px-0 py-4"> <button class="btn btn-lg btn-outline-primary btn-next"> Get Started </button> </div> </div>`;
// Exports
export default code;